import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';

import MovixIs from '~/src/features/tariffBuilder/components/popups/MovixIs';
import CheckSmartTvContainer from '~/src/features/tariffBuilder/containers/CheckSmartTvContainer';
import DecodersContainer from '~/src/features/tariffBuilder/containers/DecodersContainer';

const DecodersBlock = (): JSX.Element => {
    return (
        <ListContainer $desktop={24} $mobile={16}>
            <TextWrapper>
                <H3>Выберите модель ТВ приставки</H3>
                <Paragraph4 $smaller>Приставка нужна, чтобы смотреть ТВ-каналы и подписки.&nbsp;<MovixIs/></Paragraph4>
            </TextWrapper>

            <DecodersContainer/>

            <CheckSmartTvContainer/>
        </ListContainer>
    );
};

export default DecodersBlock;
